export function buttonIcon_filedMirgrants(node) {
  if (node.data?.design?.icon_color && !node.data?.design?.self_color) {
    node.data.design.self_color = node.data.design.icon_color
  }

  if (node.data?.hover?.icon_hoverColor && !node.data?.hover?.self_hoverColor) {
    node.data.hover.self_hoverColor = node.data.hover.icon_hoverColor
  }

  return node
}
